<template>
    <div>
        <v-card elevation="0">
            <v-card-title class="text-h6">Set Instruction Start/End Date</v-card-title>
            <v-card-text v-if="!loading">
                <v-simple-table style="border: none;">
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th>Code</th>
                                <th>Description</th>
                                <th style="text-align:center;">Start Date</th>
                                <th style="text-align:center;">End Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="code in codes" :key="code.code">
                                <td>{{ code.code }}</td>
                                <td>{{ code.description }}</td>
                                <td>
                                    <v-menu
                                        v-model="code.menustart"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="code.startdate"
                                                dense
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                hide-details
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="code.startdate"
                                            :show-current="today"
                                            no-title
                                            @input="code.menustart = false"
                                        ></v-date-picker>
                                    </v-menu>
                                </td>
                                <td>
                                    <v-menu
                                        v-model="code.menuend"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="code.enddate"
                                                dense
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                hide-details
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="code.enddate"
                                            :show-current="code.startdate"
                                            no-title
                                            @input="code.menuend = false"
                                        ></v-date-picker>
                                    </v-menu>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card-text>
            <v-card-actions v-if="!loading">
                <v-spacer></v-spacer>
                <v-dialog v-model="dialogConfirm" width="700" persistent>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn color="#80CBC4" dark v-bind="attrs" v-on="on">Save Changes</v-btn>
                    </template>
                    <v-card>
                        <v-toolbar color="#80CBC4" dark>
                            <v-toolbar-title>Confirm Update?</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="dialogConfirm = false">
                                <v-icon>mdi-close-thick</v-icon>
                            </v-btn>
                        </v-toolbar><br />
                        <v-card-text>
                            The change&#40;s&#41; made will now be applied to the new postings from now on. Proceed?
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn text color="#FB4570" @click="dialogConfirm = false">Discard</v-btn>
                            <v-btn text color="#00B1B0" @click="setControl" :loading="updateloading">Update</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-card-actions>
            <v-row 
                class="fill-height"
                align-content="center"
                justify="center"
                v-else
            >
                <v-container style="height: 400px;">
                    <v-row
                        class="fill-height"
                        align-content="center"
                        justify="center"
                    >
                        <v-col
                            class="text-subtitle-1 text-center"
                            cols="12"
                        >
                            Calling saved dates...
                        </v-col>
                        <v-col cols="6">
                            <v-progress-linear
                                color="#80CBC4"
                                indeterminate
                                rounded
                                height="6"
                            ></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-container>
            </v-row>
        </v-card>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
export default {
    data(){
        return {
            host: location.hostname.toString(),
            loading: true,
            codes: [],
            dialogConfirm: false,
            updateloading: false
        }
    },
    methods: {
        initialize(){
            const that = this;
            that.getControl();
        },
        getControl(){
            const that = this;

            that.loading = true;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getFormControl&data={"type":"instructiondates"}';

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        if(json.data.length > 0){
                            json.data[0].config.dates.forEach(element => {
                                element["menustart"] = false;
                                element["menuend"] = false;
                            });

                            that.codes = json.data[0].config.dates;
                        }else {
                            that.codes = [
                                {"code": "0", "description": "Full Year", "startdate": "", "enddate": "", "menustart": false, "menuend": false},
                                {"code": "1", "description": "Fall", "startdate": "", "enddate": "", "menustart": false, "menuend": false},
                                {"code": "2", "description": "Winter", "startdate": "", "enddate": "", "menustart": false, "menuend": false},
                                {"code": "5", "description": "Full Year", "startdate": "", "enddate": "", "menustart": false, "menuend": false},
                                {"code": "6", "description": "Fall", "startdate": "", "enddate": "", "menustart": false, "menuend": false},
                                {"code": "7", "description": "Winter", "startdate": "", "enddate": "", "menustart": false, "menuend": false},
                                {"code": "Q5", "description": "Full Year", "startdate": "", "enddate": "", "menustart": false, "menuend": false},
                                {"code": "C", "description": "Distance Studies - 12 weeks", "startdate": "", "enddate": "", "menustart": false, "menuend": false},
                                {"code": "C3", "description": "Distance Studies - 12 weeks", "startdate": "", "enddate": "", "menustart": false, "menuend": false},
                                {"code": "C1", "description": "Distance Studies - First 6 weeks", "startdate": "", "enddate": "", "menustart": false, "menuend": false},
                                {"code": "C2", "description": "Distance Studies - Second 6 weeks", "startdate": "", "enddate": "", "menustart": false, "menuend": false},
                                {"code": "B", "description": "Intersession - 6 weeks", "startdate": "", "enddate": "", "menustart": false, "menuend": false},
                                {"code": "B3", "description": "Intersession - 6 weeks", "startdate": "", "enddate": "", "menustart": false, "menuend": false},
                                {"code": "B1", "description": "Intersession - First 3 weeks", "startdate": "", "enddate": "", "menustart": false, "menuend": false},
                                {"code": "B2", "description": "Intersession - Second 3 weeks", "startdate": "", "enddate": "", "menustart": false, "menuend": false},
                                {"code": "S", "description": "Summer Day - 6 weeks", "startdate": "", "enddate": "", "menustart": false, "menuend": false},
                                {"code": "S3", "description": "Summer Day - 6 weeks", "startdate": "", "enddate": "", "menustart": false, "menuend": false},
                                {"code": "S1", "description": "Summer Day - First 3 weeks", "startdate": "", "enddate": "", "menustart": false, "menuend": false},
                                {"code": "S2", "description": "Summer Day - Second 3 weeks", "startdate": "", "enddate": "", "menustart": false, "menuend": false},
                                {"code": "N", "description": "Summer Evening - 12 weeks", "startdate": "", "enddate": "", "menustart": false, "menuend": false},
                                {"code": "N3", "description": "Summer Evening - 12 weeks", "startdate": "", "enddate": "", "menustart": false, "menuend": false},
                                {"code": "N1", "description": "Summer Evening - First 6 weeks", "startdate": "", "enddate": "", "menustart": false, "menuend": false},
                                {"code": "N2", "description": "Summer Evening - Second 6 weeks", "startdate": "", "enddate": "", "menustart": false, "menuend": false},
                            ]
                        }
                    }else {
                        that.setSnackbar("Warning: "+json.message, "#EF6C00"); //orange
                    }

                    that.loading = false;
                })
                .catch(function (err) {
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.loading = false;
                })
        },
        setControl(){
            const that = this;
            that.updateloading = true;

            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';

            let instructiondate = [];

            that.codes.forEach(element => {
                instructiondate.push({
                    "code": element["code"], "description": element["description"], "startdate": element["startdate"], "enddate": element["enddate"]
                });
            });
            
            let instruction = {
                type: "instructiondates",
                dates: instructiondate
            };

            const formData = new FormData();

            formData.append("mode", "setFormControl");
            formData.append("data", JSON.stringify(instruction));

            //API calling
            fetch(api,{
                    method: "POST",
                    body: formData
                })
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {
                        that.setSnackbar("Updated Instruction Start/End Dates", "#388E3C"); //green
                    }

                    that.updateloading = false;
                    that.dialogConfirm = false;
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.updateloading = false;
                })
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    },
    created(){
        const that = this;
        that.initialize();
    }
}
</script>